export default {
  SUCCESS_SUBMIT_CONTACT_US_FORM:
    'Terima kasih, tim kami akan membalas pertanyaan Anda dalam waktu 1x24 jam.',
}
